module.exports = __webpack_public_path__ + "static/media/signage-industrial-img30.37a36023.jpg";